<template>
  <div class="py-5">
    <div class="d-flex flex-column align-items-center text-center">
      <p class="mb-2">
        <a href="https://telegra.ph/Reglament-Toplivo-10-17" target="_blank" rel="noopener noreferrer">
          НАЖМИ ТУТ. Читать Регламент топливо
        </a>
      </p>
    </div>

    <b-form-checkbox-group
        id="checked-fuel"
        v-model="selected"
        :options="fuel.map(el => ({ value: el.id, text: el.name }))"
        name="checked-fuel"
        class="text-center p-3"
        :disabled="onProcess"
    />

    <b-card
        v-for="item in fuel"
        :key="item.id"
        class="w-75 mx-auto mb-1"
        :title="item.name"
        v-show="selected.includes(item.id)"
    >
      <label class="small m-0 p-0">Введите объем топлива, заправленного на АЗС:</label>
      <div class="d-inline-flex align-items-center">
        <b-form-input
            type="number"
            :value="item.value === null || item.value === undefined ? '' : item.value"
            @input="v => onCountChange(item, v)"
            :id="`fuel-${item.id}`"
            size="sm"
            placeholder="0"
        />
        <span class="ml-2">{{ item.unit }}</span>
      </div>

      <div>
        <label class="small m-0 p-0">Примечание:</label>
        <AppTextarea
            :value="(item.note || '').replaceAll('-->', '\n').trim()"
            @input="v => onNoteChange(item, v)"
            placeholder="Введите примечания.."
            size="sm"
            class="mt-2"
        />
      </div>
    </b-card>
  </div>
</template>

<script>
export default {
  name: 'StepSeven',

  computed: {
    fuel() {
      return this.$store.state.shiftReport.fuel || [];
    },
    onProcess() {
      return this.$store.state.shiftReport.onProcess;
    }
  },

  data() {
    return { selected: [] };
  },

  watch: {
    // Синхронизация выбора чекбоксов со стором + обновление кэша
    selected(newIds) {
      this.$store.commit('shiftReport_setSelectedFuelIds', newIds);
      this.$store.dispatch('shiftReport_updateCache');
      this.$emit('can-continue', { value: true });
    }
  },

  methods: {
    onCountChange({ id }, value) {
      const normalized = (value === '' ? '' : Number(value));
      const upd = this.fuel.map(el => el.id === id ? { ...el, value: normalized } : el);
      this.$store.commit('shiftReport_setFuel', upd);
      this.$store.dispatch('shiftReport_updateCache');
      this.$emit('can-continue', { value: true });
    },
    onNoteChange({ id }, value) {
      const upd = this.fuel.map(el => el.id === id ? { ...el, note: value.trim() } : el);
      this.$store.commit('shiftReport_setFuel', upd);
      this.$store.dispatch('shiftReport_updateCache');
      this.$emit('can-continue', { value: true });
    }
  },

  mounted() {
    this.$emit('can-continue', { value: true });
    // Не автоселектим по значениям — подхватываем то, что уже выбрал пользователь ранее
    const saved = this.$store.state.shiftReport.selectedFuelIds || [];
    this.selected = Array.isArray(saved) ? saved : [];
  }
}
</script>

<style scoped>
</style>
